var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewMatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewMatch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.0%",
    y: "-32.0%",
    width: "164.0%",
    height: "164.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1.35351078,1.45532889 C-0.452203951,3.39485564 -0.450136273,6.50843121 1.35351078,8.44949263 L8.71842707,16.3770535 C8.79075691,16.4555347 8.89137108,16.5 8.99662551,16.5 C9.10187993,16.5 9.20249411,16.4555347 9.27482394,16.3770535 C11.7321445,13.7376051 14.1883742,11.0951504 16.6457139,8.45564308 C18.4514287,6.51608292 18.4514287,3.40102771 16.6457139,1.46146951 C14.8400183,-0.478086715 11.8882351,-0.478129945 10.0825203,1.46146951 L8.99961215,2.62204825 L7.91672317,1.45532889 C7.01385621,0.485549789 5.82080593,2.23394753e-14 4.63212076,2.23394753e-14 C3.44343558,0 2.2563586,0.485547824 1.35351078,1.45532889 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.639157869,0.66151313 C-0.213540755,1.5431162 -0.212564351,2.95837782 0.639157869,3.84067847 L4.11703501,7.44411521 C4.15119076,7.47978852 4.19870301,7.5 4.24840649,7.5 C4.29810997,7.5 4.34562222,7.47978852 4.37977797,7.44411521 C5.54017935,6.24436597 6.70006559,5.04325016 7.86047601,3.84347413 C8.71317466,2.96185587 8.71317466,1.54592169 7.86047601,0.664304325 C7.0077864,-0.217312143 5.61388878,-0.217331793 4.76119013,0.664304325 L4.24981685,1.19184011 L3.73845261,0.66151313 C3.31209877,0.220704449 2.74871391,1.0154307e-14 2.18739036,1.0154307e-14 C1.6260668,0 1.06550267,0.220703556 0.639157869,0.66151313 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35351078,7.95532889 C-0.452203951,9.89485564 -0.450136273,13.0084312 1.35351078,14.9494926 L8.71842707,22.8770535 C8.79075691,22.9555347 8.89137108,23 8.99662551,23 C9.10187993,23 9.20249411,22.9555347 9.27482394,22.8770535 C11.7321445,20.2376051 14.1883742,17.5951504 16.6457139,14.9556431 C18.4514287,13.0160829 18.4514287,9.90102771 16.6457139,7.96146951 C14.8400183,6.02191329 11.8882351,6.02187006 10.0825203,7.96146951 L8.99961215,9.12204825 L7.91672317,7.95532889 C7.01385621,6.98554979 5.82080593,6.5 4.63212076,6.5 C3.44343558,6.5 2.2563586,6.98554782 1.35351078,7.95532889 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.639157869,0.66151313 C-0.213540755,1.5431162 -0.212564351,2.95837782 0.639157869,3.84067847 L4.11703501,7.44411521 C4.15119076,7.47978852 4.19870301,7.5 4.24840649,7.5 C4.29810997,7.5 4.34562222,7.47978852 4.37977797,7.44411521 C5.54017935,6.24436597 6.70006559,5.04325016 7.86047601,3.84347413 C8.71317466,2.96185587 8.71317466,1.54592169 7.86047601,0.664304325 C7.0077864,-0.217312143 5.61388878,-0.217331793 4.76119013,0.664304325 L4.24981685,1.19184011 L3.73845261,0.66151313 C3.31209877,0.220704449 2.74871391,1.0154307e-14 2.18739036,1.0154307e-14 C1.6260668,0 1.06550267,0.220703556 0.639157869,0.66151313 Z",
    id: "path-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Favourite-Swipe-I-have-fav-Copy",
    transform: "translate(-29.000000, -130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icViewMatch",
    filter: "url(#filter-1)",
    transform: "translate(33.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/MutualMatch_New"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(1.000000, 7.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A5A5A5",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    mask: "url(#mask-3)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.500000, -0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 21 0 21 18 0 18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(15.500000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    mask: "url(#mask-5)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.500000, -5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 16 0 16 16 0 16"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Icons/HeartOutline_Match",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Chat-filled-Copy-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(14.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    xlinkHref: "#path-8"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewMatch);
export default __webpack_public_path__ + "static/media/icViewMatch.2a411848ff4ddd74901bc7b82be17e21.svg";
export { ForwardRef as ReactComponent };